import RespondTo from "./respond-to";
import React from "react";
import PropTypes from "prop-types";
import { Loading, Icon } from "@evertrue/et-components";
import numeral from "numeral";
import { PromiseResolverLoading } from "@evertrue/promise-resolver";
import { WithPromises } from "../contexts/api-context";
import get from "lodash.get";

const propTypes = {
  stagesForGroup: PropTypes.array,
  assigned: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  prospectsTotal: PropTypes.number,
  hasStagesFeature: PropTypes.bool,
  poolId: PropTypes.number,
  promises: PropTypes.object,
  solicitorContactId: PropTypes.number,
};

const EmptyState = () => {
  return (
    <div className="stage-report--section">
      <div className="stage-report--not-enabled">Stages Not Enabled</div>

      <Icon className="stage-report--icon" size={4} icon="community" />
    </div>
  );
};

const StageReport = ({
  stagesForGroup,
  assigned = "all",
  prospectsTotal = 0,
  hasStagesFeature,
  poolId,
  promises,
  solicitorContactId,
}) => {
  const stages = stagesForGroup.map(group => group.stage);
  return !hasStagesFeature ? (
    <EmptyState />
  ) : (
    <PromiseResolverLoading
      LoadingComponent={<Loading />}
      promise={() =>
        promises.stageStatsQuery({ poolId, stages, assigned, solicitorContactId }).then(res => {
          const ret = get(res, "stats.assignment_id", []).reduce((accum, current) => {
            accum[current.group_by_field_value] = current.stats.count;
            return accum;
          }, {});

          return ret;
        })
      }
      args={{ stages, assigned }}
    >
      {({ data }) =>
        stagesForGroup.length ? (
          <React.Fragment>
            <div className="pool-report--label">Pool Stage Name</div>
            <RespondTo className="stage-report--stage-container">
              {stagesForGroup.map(stage => {
                const count_for_stage = data[stage.stage] || 0;
                const percentage = count_for_stage / prospectsTotal;
                return (
                  <div key={stage.id} className="pool-report--stage">
                    <span>{stage.stage}</span>
                    <span> {numeral(percentage).format("%0.[00]")} </span>
                  </div>
                );
              })}
            </RespondTo>
          </React.Fragment>
        ) : (
          <EmptyState />
        )
      }
    </PromiseResolverLoading>
  );
};

StageReport.propTypes = propTypes;
StageReport.defaultProps = {
  pool: {},
  stagesForGroup: [],
  assigned: "all",
  prospectsTotal: 0,
  hasStagesFeature: false,
};

export default WithPromises(StageReport);
